export default {
  name: 'team-card',
  components: {},
  props: {
    person: Object,
  },
  data() {
    return {

    }
  },
  computed: {

  },
  mounted() {

  },
  methods: {

  }
}